import React from "react";
import { Box, Typography } from "@mui/material";
import { StyledBookingFlowButton } from "../BookingScheduleContainer/BookingScheduleContainer.style";
import { MODALS } from "../../../config/params";
import { useModal } from "../../../context/ModalContext";

export const DEFAULT_ERROR_IMAGE = "/assets/images/empty-image.svg";

export interface IWellnessPlanErrorPageCta {
  label: string;
  onClick: () => void;
}

export interface IWellnessPlanErrorPageProps {
  title: string;
  description: string;
  imageSrc?: string;
  primaryCta?: IWellnessPlanErrorPageCta;
}

const buttonBaseSx = {
  fontFamily: "geograph-medium, sans-serif",
  fontSize: "14px",
  lineHeight: "14px",
  fontWeight: 500,
  height: "40px",
  borderRadius: "100px",
  textTransform: "none",
} as const;

const WellnessPlanErrorPage = ({
  title,
  description,
  imageSrc = DEFAULT_ERROR_IMAGE,
  primaryCta,
}: IWellnessPlanErrorPageProps) => {
  const { openModal } = useModal();

  return (
    <Box className="flex w-full h-full justify-center items-center">
      <Box className="flex flex-col items-center gap-4 py-6 w-full max-w-[500px]">
        <img src={imageSrc} height={220} width={220} alt="" />
        <Typography
          className="!text-[24px] !text-black"
          textAlign="center"
          sx={{ fontFamily: "geograph-medium, sans-serif" }}
        >
          {title}
        </Typography>
        <Typography
          variant="body1"
          className="!text-[16px] !text-light-black"
          textAlign="center"
          sx={{ fontFamily: "geograph-regular, sans-serif" }}
        >
          {description}
        </Typography>
        {primaryCta && (
          <StyledBookingFlowButton
            fullWidth
            color="primary"
            size="small"
            onClick={primaryCta.onClick}
            sx={buttonBaseSx}
          >
            {primaryCta.label}
          </StyledBookingFlowButton>
        )}
        <StyledBookingFlowButton
          fullWidth
          variant="outlined"
          size="small"
          onClick={() => openModal(MODALS.CUSTOMER_SUPPORT_MODAL)}
          sx={{
            ...buttonBaseSx,
            "color": "#000000",
            "backgroundColor": "transparent",
            "border": "1px solid #DAD7D6",
            "&:hover": {
              backgroundColor: "transparent",
              border: "1px solid #DAD7D6",
            },
          }}
        >
          Contact Support
        </StyledBookingFlowButton>
      </Box>
    </Box>
  );
};

export default WellnessPlanErrorPage;
